import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './reducer'
import * as state from './state'
import * as R from 'ramda'
import { IncidentView } from './model'
import { categories } from './constants'
import {
  createdBySystemNameMappings,
  getItemCategoryOptions,
  selectRentalEntities,
  selectUserEntities,
  userFullname,
} from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'
export const incidentState = createFeatureSelector<state.State>('incident')

export const selectAllIncidents = createSelector(incidentState, reducer.selectAll)
export const selectIncidentEntities = createSelector(incidentState, reducer.selectEntities)

export const selectIncidentsLoaded = createSelector(incidentState, (s: state.State) => s.isLoaded)
export const isUpdatingIncidents = createSelector(incidentState, (s: state.State) => s.isUpdating)

export const selectIncidents = createSelector(
  selectAllIncidents,
  selectRentalEntities,
  selectUserEntities,
  (incidents, rentalEntities, usersById) => {
    return R.map((incident: IncidentView) => {
      const rental = rentalEntities[incident.rental_id]
      const reviewer = usersById[incident.reviewer_id]
      const reporter = usersById[incident.reporter_id]

      return {
        ...incident,
        rentalView: R.pathOr('', ['name'], rental),
        reporterView: reporter ? userFullname(reporter) : createdBySystemNameMappings[incident.reporter_id] || '',
        reviewerView: userFullname(reviewer),
        rental,
      }
    }, incidents) as IncidentView[]
  }
)

export const selectIncidentById = (id: string) =>
  createSelector(selectAllIncidents, (items) => {
    return items?.find((item) => item.pkey === id)
  })

export const selectIncidentsByIds = (ids: string[]) =>
  createSelector(selectAllIncidents, (items) => {
    return items.filter((t) => ids.includes(t.pkey))
  })

export const selectIncidentsFromBookingMessages = (bookingId: string) =>
  createSelector(selectAllIncidents, (incidents) => {
    return incidents.filter((incident) => incident.inquiry_id === bookingId && !!incident.message_id)
  })

export const selectIncidentsFromMessage = createSelector(selectAllIncidents, (incidents) => {
  return incidents.filter((incident) => !!incident.message_id)
})

export const selectIncidentByMessageId = (messageId: string) =>
  createSelector(selectAllIncidents, (incidents) => {
    return incidents.find((incident) => incident.message_id === messageId)
  })

export const selectIncidentsFromReview = createSelector(selectAllIncidents, (incidents) => {
  return incidents.filter((incident) => !!incident.review_id)
})

export const selectIncidentByReviewId = (reviewId: string) =>
  createSelector(selectAllIncidents, (incidents) => {
    return incidents.find((incident) => incident.review_id === reviewId)
  })

export const selectAllIncidentCategories = createSelector(selectAllIncidents, (incidents) => {
  return getItemCategoryOptions(incidents, categories)
})
